var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.platform.workflows",
  title: "EGT Platform — Workflows",
  description: "When something happens, the follow-up runs itself — trigger to steps, in the background.",
  supportServer: true,
  fields: { reserveUrl: { title: "Reserve URL", type: "uri", description: "Reservation entry point.", required: false } }
});
var P = require("../helpers/egt.platform.sections.js");

exports.render = async function render(options) {
  var reserve = (options && options.reserveUrl) || "/reserve";
  return P.capabilityPage({
    id: "workflows", reserve: reserve,
    media: { video: "/vis/uatools-anim.mp4", poster: "/vis/uatools-anim.png", parallax: 0.06 },
    eyebrow: "The Universe Platform · Workflows",
    title: [ "When something happens, ", { n: "br" }, "the follow-up ", { n: "span", c: "egt__gold", i: "runs itself." } ],
    lead: "Describe the outcome once — a thank-you, a tag, a hand-off — and it happens every time, quietly, in order. The work you'd forget, handled.",
    /* SEO wave 2C-5/2C-7 (2026-10-09): answer-first definition, who it's for,
     * and straight answers drawn only from objections the site already answers. */
    answer: "Workflows is the automation inside the Universe Platform by EGT: describe a follow-up once — a thank-you, a tag, a hand-off — and it runs every time the moment comes, for businesses whose to-do list keeps outgrowing the day. It's part of the public beta.",
    forTitle: "For owners who are tired of remembering.",
    forWho: [
      { title: "Teams doing everything themselves", copy: "The follow-ups nobody has time to remember still happen — in order, every time." },
      { title: "Businesses tired of the glue", copy: "Automation acts on the same records as your site, store and email, so there's no separate tool to wire up and babysit." },
      { title: "Owners who want results, not busywork", copy: "The work runs quietly in the background. You see the result, not the steps." }
    ],
    faq: [
      [ "Does every automation I can imagine exist today?",
        "Not every one, and we won't pretend otherwise. The workflow runner runs today, and we grow what it can do carefully. We say “automation runs,” never “every automation.”" ],
      [ "Does it run on copies of my data?",
        "No. Workflows act on the same records as everything else, so they never run on stale or copied data." ]
    ],
    spineEyebrow: "What it does",
    spineTitle: "Describe it once. Done forever.",
    spineLead: "Automation here isn't a separate tool you wire up to your data — it acts on the same system, so it always knows what just happened.",
    points: [
      { title: "Trigger to steps", copy: "Something happens; the next steps run in order, on their own — no one has to remember to do them." },
      { title: "On the real system", copy: "Workflows act on the same records as everything else, so they never run on stale or copied data." },
      { title: "Quiet by default", copy: "The follow-up happens in the background. You see the result, not the busywork." }
    ],
    honesty: "Automation that runs — honestly scoped.",
    honestyLead: "The workflow runner runs today, and we grow what it can do carefully. We say \"automation runs,\" never \"every automation\" — because we mean it.",
    honestyMedia: { img: "/imgs/egt-platform-canvas.jpg", alt: "", parallax: true }
  });
};
